import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import AsyncReactSelect from '../async-react-select'
import { useRentalPageDetector } from '../../hooks/use-rental-page-detector'
import CATEGORY_COMPONENT_ITEM_FRAGMENT from '../../../graphql/fragments/category.gql'
import styles from './category-navigation-selector.css'
import {
  customReactSelectStyles,
  customReactSelectTheme
} from '../forms/select-custom-syles'

function CategoryNavSelector({
  categoryItems: options,
  selectedCategory,
  selectKeyValue
}) {
  const MIN_DROPDOWN_WIDTH = 180
  const DROPDOWN_ICON_PADDING = 36
  const CHAR_WIDTH_PX = 10

  const history = useHistory()
  const isOnARentalPage = useRentalPageDetector()
  const [selectedOption, setSelectedOption] = useState(selectedCategory)
  const searchIsClicked = useSelector(state => state.navigation.searchIsClicked)

  // Use the longest category name to estimate the dropdown width.
  const dropdownWidth = useMemo(() => {
    const longestLabelLength = Math.max(
      0,
      ...(options || []).map((option) => String(option?.name || '').length)
    )
    const estimatedContentWidth = longestLabelLength * CHAR_WIDTH_PX
    return Math.max(MIN_DROPDOWN_WIDTH, estimatedContentWidth + DROPDOWN_ICON_PADDING)
  }, [options])

  const onSelectionChange = (option) => {
    const pathname = option.path || '/404'
    history.push(pathname)
    setSelectedOption(option)
  }

  return (
    <div className={classnames(styles.wrapper, {
      [styles.wrapperWithSearchBox]: searchIsClicked
    })}
    >
      <AsyncReactSelect
        styles={customReactSelectStyles({
          isKid: false,
          isRentalThemed: isOnARentalPage,
          width: dropdownWidth
        })}
        theme={customReactSelectTheme({
          isKid: false,
          isRentalThemed: isOnARentalPage
        })}
        getOptionLabel={option => option[selectKeyValue]}
        getOptionValue={option => option.id}
        defaultValue={selectedOption}
        labelKey={selectKeyValue}
        formatOptionLabel={option => (
          <div key={option.id} className={styles.option}>
            {option[selectKeyValue]}
          </div>
        )}
        options={options}
        onChange={(option) => onSelectionChange(option)}
        isSearchable={false}
        isClearable={false}
        deleteRemoves={false}
        backspaceRemoves={false}
      />
    </div>
  )
}

CategoryNavSelector.propTypes = {
  categoryItems: PropTypes.arrayOf(propType(CATEGORY_COMPONENT_ITEM_FRAGMENT))
    .isRequired,
  selectedCategory: propType(CATEGORY_COMPONENT_ITEM_FRAGMENT).isRequired,
  selectKeyValue: PropTypes.string.isRequired
}

export default CategoryNavSelector
